import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

const holdingShape = ImmutablePropTypes.mapContains({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  metadataId: PropTypes.string.isRequired,
  resourceURIs: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  appliesToResourcePart: PropTypes.string
});

export default holdingShape;
